module.exports = __webpack_public_path__ + "static/img/home_map_img3.a9dfb248.png";